<template></template>
<script>
import { mapActions } from 'vuex'
import { navConfig, confConfigPercent0, confConfigPercent1, confConfigalpha1 } from '@/page/newCouponsCenter/common/enums'
import { setTitle } from '@/common/js/bridge'

export default {
  props: {
    title: {
      default: ''
    }
  },
  data () {
    return {
      navConfig: {},
      alpha: 0 // 导航栏透明度是否达到。 1是完全不透明。 0是透明
    }
  },
  computed: {
    // 是否支持沉浸式
    isSupportHurdle () {
      return this.$store.state.isSupportHurdle
    },
    pageTitle () {
      return this.title
    }
  },
  async created () {
    setTitle(this.title)
    await this.versionControl()
    this.navConfig = navConfig(this.pageTitle)
    // 设置标题栏及状态栏初始样式
    this.isSupportHurdle && this.updateNav(this.navConfig)
  },
  async mounted () {
    // 监听落地页页面滚动事件
    document.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed () {
    document.removeEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    ...mapActions({
      versionControl: 'versionControl'
    }),
    // 滚动监听的方法
    handleScroll () {
      const absY = Math.abs(document.documentElement.scrollTop || document.body.scrollTop)
      // 临界值,上滑到90的时候 titlebar要透明度100%的展现出来
      const criticalY = 104
      const percent = absY / criticalY
      this.isSupportHurdle && this.setNavStyle(percent)
    },
    // 设置titlebar样式
    setNavStyle (percent) {
      let confConfig = {}
      if (percent <= 0) {
        confConfig = confConfigPercent0(this.pageTitle)
      } else if (percent <= 1) {
        confConfig = confConfigPercent1(percent, this.pageTitle)
        if (percent < 0.5) {
          confConfig.backBtn.color = '#FFFFFF'
          confConfig.backBtn.alpha = 1 - percent
        } else {
          confConfig.backBtn.color = '#000000'
        }
      } else {
        // 兼容用户滑动速度过快以至于所计算的percent还未到达1时滑动距离已经超过临界值导致状态栏透明度固定在小于1的值不动了。
        // 所以在此做个判断。如果标题栏透明度已经为1时不作为。没到1时需要将其设置为1.
        if (this.alpha < 1) confConfig = confConfigalpha1(this.pageTitle)
      }
      this.alpha = percent
      this.updateNavConfig(confConfig)
      this.updateNav(this.navConfig)
    },
    /*
    * 页面滑动时更新标题栏和状态栏的配置。
    * 目前是固定标题和返回按钮的颜色来控制它的透明度。
    * 状态栏sysStatusBar只有在页面初始和返回顶部时的颜色为白色。滑动时一直是黑色。所以这里默认是黑色0
    * shareBtn分享按钮的透明度为1
    */
    updateNavConfig (confConfig = {}) {
      this.navConfig = Object.assign({}, this.navConfig, confConfig)
    },
    updateNav (params) {
      this.SodaBridge('updateNav', params)
    }
  }
}
</script>
